import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  picks:{
    width: '100%',
  },
  card:{
    padding: '1.5rem',
    overflow: 'visible',
    minHeight: '50vh',
    width: '30vw',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  cardAction:{
    padding: '16px'
  },
  formStyle:{
    display:'flex',
    minHeight: '400px',
    padding: '2rem',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '& > *':{
      marginTop: '2rem'
    }
  },
  pick:{
    display:'flex',
    justifyContent:'space-between'
  },
  buttonStart:{
    borderSize: '1px',
    textTransform: 'none',
    marginTop:'3rem',
  },
  pickBody: {
    width: '48%'
  },
  teamName: {
    marginBottom: '1rem'
  }
}))